import { UserInfo } from "@/components/User/components/UserInfo";

export const HeaderDrawerItems = () => {
	
	return <>
		<UserInfo />
	</>
}
